module.exports = __webpack_public_path__ + "img/main-box.00538cd3.svg";